var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAttribute = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.021 4.005a1.17 1.17 0 0 1 .933.337l8.703 8.704a1.17 1.17 0 0 1 0 1.653L14.7 19.657a1.17 1.17 0 0 1-1.653 0l-8.704-8.703a1.17 1.17 0 0 1-.337-.932l.413-4.545a1.17 1.17 0 0 1 1.058-1.059l4.545-.413ZM8.363 6.16A1.559 1.559 0 1 0 6.16 8.364a1.559 1.559 0 0 0 2.204-2.205Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAttribute);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/attribute.e68e4c753dbc7ab201a2a6c72e15ab5b.svg";